import { lazy } from "react";
import ProtectedRoute from "../components/shared/ProtectedRoute";
import { Route, Routes } from "react-router-dom";

const NotificationList = lazy(() => import("../pages/Notifications/NotificationList"));

export default function NotificationRoutes() {
  return (
    <Routes>
      <Route
        path="/list"
        element={
          <ProtectedRoute permission="*">
            <NotificationList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute permission="*">
            <NotificationList />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
} 